module.exports = __webpack_public_path__ + "img/dreams-mini-portrait.8a9f1dc.png";